import React, { Component } from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps";
import SearchBox from "react-google-maps/lib/components/places/SearchBox";

// Muestra un mapa de Google Maps con un buscador y permite
// seleccionar un punto -que agrega como marcador-
// y devuelve la latitud y longitud del mismo

class Map extends Component {
    constructor(props) {
        super(props);
        this.state = {
            marker: null,
            lat: 0,
            lng: 0
        }
    }

    onPlacesChanged = () => {
        const places = this.searchBox.getPlaces();
        const bounds = new google.maps.LatLngBounds();

        places.forEach(place => {
          if (place.geometry.viewport) {
            bounds.union(place.geometry.viewport)
          } else {
            bounds.extend(place.geometry.location)
          }
        });

        this.map.fitBounds(bounds);
  }

    onMapClick = e => {
        const lat = e.latLng.lat();
        const lng = e.latLng.lng();

        this.setState(
            () => ({ marker: { lat, lng }}),
            () => this.props.onChange(this.state.marker)
        );
    }


    render() {
        return (
            <GoogleMap
                ref={map => { this.map = map; }}
                defaultZoom={14}
                defaultCenter={{ lat: -39.0204943, lng: -67.6118184 }}
                mapTypeId={this.props.type || 'roadmap'}
                defaultOptions={{
                    clickableIcons: false,
                    disableDefaultUI: true,
                    fullscreenControl: false
                }}
                onClick={this.onMapClick}
            >

                <SearchBox
                    ref={ref => { this.searchBox = ref; }}
                    controlPosition={google.maps.ControlPosition.LEFT_TOP}
                    onPlacesChanged={this.onPlacesChanged}
                >
                    <input
                        type="text"
                        placeholder="Buscar un sitio"
                        style={{
                            boxSizing: `border-box`,
                            border: `1px solid transparent`,
                            width: `400px`,
                            maxWidth: `80%`,
                            height: `32px`,
                            marginTop: `15px`,
                            marginLeft: `15px`,
                            padding: `0 12px`,
                            boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                            fontSize: `14px`,
                            outline: `none`,
                            textOverflow: `ellipses`,
                        }}
                    />
                </SearchBox>

                { this.state.marker && 
                    <Marker position={this.state.marker} />
                }
            </GoogleMap>
        );
    }
}

const PositionSelector = withScriptjs(withGoogleMap(props =>
    <Map {...props} markers={props.markers} />
));

export default PositionSelector;


// WEBPACK FOOTER //
// ./src/components/ParadigmaGoogleMap/PositionSelector.js